import { SettingsSubModule } from '../utils/settings-sub-module';
import { SettingValue } from '../utils/setting-value';
import { SettingsModule } from '../utils/settings-module';

export namespace QmsSupplierQualificationTypesFields {
  export enum CommonField {
    SupplierTypesSequentialNumberingFormat = 'SupplierTypes.SequentialNumberingFormat',
  }
}

class CommonConfig extends SettingsSubModule {
  @SettingsSubModule.value(QmsSupplierQualificationTypesFields.CommonField.SupplierTypesSequentialNumberingFormat, '')
  sequentialNumberingFormat: SettingValue<string>;
}

export class QmsSupplierQualificationTypesModule extends SettingsModule {
  @SettingsModule.value(CommonConfig) common: CommonConfig;
}
